<template>
    <div :class="type === 'time' ? 'time-opt-container' : 'opt-container'">
        <div class="delete" @click="$emit('deleteTime')">
            <i class="el-icon-delete"></i>
        </div>
        <div class="add" v-if="currentIndex === currentData.length - 1" @click="$emit('addTime')">
            <i class="el-icon-plus"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: String,
        currentIndex: Number,
        currentData: Array
    }
}
</script>

<style lang="scss" scoped>
.opt-container,
.time-opt-container {
    position: absolute;
    right: -7px;
    bottom: 0;
    transform: translateX(100%);

    .delete,
    .add {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        background-color: #cde1fd;
        border-radius: 50%;
        cursor: pointer;

        .el-icon-delete,
        .el-icon-plus {
            font-size: 16px;
            color: #165dff;
        }
    }

    .add {
        margin-top: 7px;
    }
}



.time-opt-container {
    right: 7px;
    // bottom: -6px;
    transform: translate(0);

    .delete,
    .add {
        width: 24px;
        height: 24px;

        .el-icon-delete,
        .el-icon-plus {
            font-size: 12px;
        }
    }

    .add {
        margin-top: 2px;
    }
}

.el-input {
    width: 300px;
}
</style>